module.exports = __webpack_public_path__ + "img/dallas.dccaa3a5.jpg";